/** Operator-facing labels for agent authoring UI (not raw API keys). */

export type LabeledOption = {
  value: string;
  title: string;
  description: string;
};

export const PIPELINE_TRIGGER_OPTIONS: LabeledOption[] = [
  {
    value: 'incoming_message',
    title: 'Incoming message',
    description: 'Runs when a client sends a message (chat, Telegram, playground).',
  },
  {
    value: 'after_reactions',
    title: 'After reactions',
    description: 'Runs after operators react to agent messages.',
  },
  {
    value: 'manual',
    title: 'Manual',
    description: 'Started only when an operator or system call triggers it.',
  },
  {
    value: 'schedule',
    title: 'Schedule',
    description: 'Runs on a cron schedule.',
  },
];

export const ON_FALSE_OPTIONS: LabeledOption[] = [
  {
    value: 'skip',
    title: 'Skip this step',
    description: 'Continue with the next pipeline step.',
  },
  {
    value: 'end',
    title: 'Stop pipeline',
    description: 'Finish the run successfully without remaining steps.',
  },
];

export const EMPTY_CONTEXT_BEHAVIOR_OPTIONS: LabeledOption[] = [
  {
    value: 'clarify',
    title: 'Ask a clarifying question',
    description: 'Compose a reply that asks for the missing detail.',
  },
  {
    value: 'escalate',
    title: 'Hand off to a broker',
    description: 'Prefer escalating when context is empty.',
  },
  {
    value: 'skip',
    title: 'Skip quietly',
    description: 'Do not force a special reply; continue the turn.',
  },
  {
    value: 'fallback_text',
    title: 'Use fallback text',
    description: 'Use the skill fallback text when the query is empty.',
  },
];

export const LLM_PURPOSE_LABELS: Record<string, { title: string; description: string }> = {
  skill_route: {
    title: 'Choose skills',
    description: 'Router LLM picks which skills apply to this message.',
  },
  compose_reply: {
    title: 'Compose reply',
    description: 'LLM writes the outbound message using context and skill results.',
  },
  extract_slots: {
    title: 'Extract memory',
    description: 'LLM extracts structured slots into memory.',
  },
};

export function labelForTrigger(value: string): string {
  return PIPELINE_TRIGGER_OPTIONS.find((o) => o.value === value)?.title ?? value;
}

export function labelForOnFalse(value: string): string {
  return ON_FALSE_OPTIONS.find((o) => o.value === value)?.title ?? value;
}

export function labelForEmptyContext(value: string): string {
  return EMPTY_CONTEXT_BEHAVIOR_OPTIONS.find((o) => o.value === value)?.title ?? value;
}

export function labelForLlmPurpose(purpose: string): string {
  return LLM_PURPOSE_LABELS[purpose]?.title ?? purpose;
}
